import Loadable from '@townsquare/loadable';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { usageRouteDefinition } from '@townsquare/routes/usage';

import { usageActivationResource } from './agg/usage-activation-resource';

usageRouteDefinition.resources = [usageActivationResource];

usageRouteDefinition.component = Loadable({
	loader: () =>
		import(/* webpackChunkName: "usage-view" */ './components/UsageView').then(
			({ UsageView }) => UsageView,
		),
	loading: () => null,
});

export const usageRoute: GlobalHomePageRoute = usageRouteDefinition;
